class MenuLink extends Theme.Component {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", () => {
      document.dispatchEvent(new CustomEvent("menulink:click"));
    });

    document.addEventListener("menudrawer:show", () => {
      this.classList.add("active--true");
    });

    document.addEventListener("menudrawer:hide", () => {
      this.classList.remove("active--true");
    });
  }
}

customElements.define("component-menu-link", MenuLink);

class MenuDrawer extends Theme.Component {
  constructor() {
    super();

    this.resizeHandler = Theme.Helpers.debounce(() => {
      this.hide();
      requestAnimationFrame(() => this.setStyles());
    }, 200);
  }

  connectedCallback() {
    this.setStyles();

    document.addEventListener("menulink:click", (event) => {
      this.toggle();
    });

    window.addEventListener("resize", this.resizeHandler);
  }

  toggle() {
    if (this.classList.contains("state--active")) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    setTimeout(() => {
      this.classList.add("state--active");
      document.dispatchEvent(new CustomEvent("menudrawer:show"));
    }, 50);
  }

  hide() {
    this.classList.remove("state--active");
    document.dispatchEvent(new CustomEvent("menudrawer:hide"));
  }

  setStyles() {
    const header = document.querySelector("header");
    const header_height = header?.offsetHeight || 0;

    this.style.top = header_height + "px";
    this.style.height = `calc(100% - ${header_height}px)`;
  }
}

customElements.define("menu-drawer", MenuDrawer);
